<template>
  <div>
    <baseaktarim title="SUNEXPRESS Bilet Aktarımı"
    v-model="items"
    v-on:submitfile="SubmitFile"
    :status="status"

    ></baseaktarim>
  </div>
</template>

<script>
import baseaktarim from "../aktarimbilet/baseaktarim";
import tool from "../../coper/tools";

export default {
  data() {
    return {
      items: [],
      status:tool.NewSatatus(),

    };
  },
  components: {
    baseaktarim,
  },
  methods: {
    SubmitFile(files) {
      let formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append('files[' + i + ']', file);
      }

      this.status.loading = true;
      tool.api_file_post(this, "ArkmanTicketStream/SunExpressStream", formData).then(
        response => {
          this.items = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    }
  }

};
</script>
